import { Component, Input } from '@angular/core';
import { ListTableComponent } from '../../../../shared/components/list-table/list-table.component';

@Component({
  selector: 'ppl-ignored-timesheets-summary',
  standalone: true,
  imports: [ListTableComponent],
  templateUrl: './ignored-timesheets-summary.component.html',
  styleUrl: './ignored-timesheets-summary.component.css',
})
export class IgnoredTimesheetsSummaryComponent {
  @Input() ignoredTimesheetSummaryData: any;
  cols = [
    {
      field: 'count',
      header: 'Timesheet Count',
      jsonpath: 'count',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'ignoreReason',
      header: 'Reason',
      jsonpath: 'ignoreReason',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
  ];
}
